import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function PaymentReturn({ cancel = false }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { check } = useAuth();
  const [state, setState] = useState(cancel ? "cancel" : "checking");

  useEffect(() => {
    if (cancel) return;
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/billing/status/${sid}`);
        if (data.payment_status === "paid") { await check(); setState("ok"); return; }
      } catch (e) { console.debug("payment status poll retry", e); }
      if (tries < 10) setTimeout(poll, 1500); else { await check(); setState("ok"); }
    };
    poll();
  }, [cancel, params, check]);

  return (
    <div className="grid min-h-screen place-items-center p-6">
      <div className="card-surface max-w-md space-y-4 p-8 text-center" data-testid="payment-return">
        {state === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-primary" /><h1 className="font-heading text-2xl uppercase">Spracúvame predplatné…</h1><p className="text-sm text-muted-foreground">Chvíľku strpenia, potvrdzujeme aktiváciu.</p></>}
        {state === "ok" && <><CheckCircle2 className="mx-auto h-12 w-12 text-emerald-400" /><h1 className="font-heading text-2xl uppercase">Predplatné aktivované</h1><p className="text-sm text-muted-foreground">Máte 14 dní zdarma. Prvá platba prebehne automaticky po skončení skúšobnej doby. Zrušiť môžete kedykoľvek v Nastaveniach.</p><Button className="min-h-[48px] w-full" onClick={() => navigate("/nastavenia")} data-testid="payment-continue">Pokračovať</Button></>}
        {state === "cancel" && <><XCircle className="mx-auto h-12 w-12 text-muted-foreground" /><h1 className="font-heading text-2xl uppercase">Platba zrušená</h1><p className="text-sm text-muted-foreground">Nič sa nestrhlo. Predplatné môžete aktivovať kedykoľvek neskôr.</p><Button className="min-h-[48px] w-full" onClick={() => navigate("/nastavenia")} data-testid="payment-continue">Späť do aplikácie</Button></>}
        {state === "error" && <><XCircle className="mx-auto h-12 w-12 text-destructive" /><h1 className="font-heading text-2xl uppercase">Chýba údaj o platbe</h1><Button className="min-h-[48px] w-full" onClick={() => navigate("/nastavenia")}>Späť</Button></>}
      </div>
    </div>
  );
}
